import { Controller } from '@hotwired/stimulus'

// I-UXC-itinerary-5: one collapsible group of a list table (a <tbody>): its header button shows or hides the group's
// rows. A table can't hold <details> around rows, so the button flips `hidden` and aria-expanded.
export default class RowGroupController extends Controller<HTMLElement> {
  static override targets = ['toggle', 'row']
  declare readonly toggleTarget: HTMLButtonElement
  declare readonly rowTargets: HTMLElement[]

  toggle(): void {
    const open = this.toggleTarget.getAttribute('aria-expanded') !== 'true'
    this.toggleTarget.setAttribute('aria-expanded', String(open))
    for (const row of this.rowTargets) row.hidden = !open
  }
}
